import React, { Component } from 'react'
import { Form, Select, Input, Button, message } from 'antd'
import { achieveLogin } from '../api'
const { Option } = Select

 
class AchieveAboardForm extends Component {
    constructor () {
        super()
        this.state = {
            idTypeSelectList: [],
            // 机构证件类型
            idTypeList0: [
                { title: '组织机构代码证', value: 0 },
                { title: '营业执照', value: 1 },
                { title: '行政机关', value: 2 },
                { title: '社会团体', value: 3 },
                { title: '军队', value: 4 },
                { title: '武警', value: 5 },
                { title: '下属机构', value: 6 },
                { title: '基金会', value: 7 },
                { title: '其他', value: 8 }
            ],
            // 个人证件类型
            idTypeList1: [
                { title: '身份证', value: 0},
                { title: '护照', value: 1 },
                { title: '军官证', value: 2 },
                { title: '士兵证', value: 3 },
                { title: '港澳通行证', value: 4 },
                { title: '户口本', value: 5 },
                { title: '外国护照', value: 6 },
                { title: '其他', value: 7 },
                { title: '文职证', value: 8 },
                { title: '警官证', value: 9 },
                { title: '台胞证', value: 'A' }
            ],
            captchaSrc: '/xgj/v2/website/achievementShow/captcha'
        }
    }

    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                // 请求
                this.achieveLogin(values)
            }
        })
    }

     // 获取图片验证码
     getCaptcha = () => {
        this.setState({
            captchaSrc: `/xgj/v2/website/achievementShow/captcha?t=${new Date().getTime()}`
        })    
    }

    componentDidMount () {
        this.handleIdType(1)
    }

    // 根据用户类型渲染证件类型列表
    handleIdType = (type) => {
        if (+type) {
            this.setState({
                idTypeSelectList: this.state.idTypeList1
            })
        }else {
            this.setState({
                idTypeSelectList: this.state.idTypeList0
            })
        }
    }

    // 发送登录请求
    achieveLogin (params) {
        achieveLogin(params).then(res => {
            if (res.code === 'Success') {
                this.props.form.resetFields()
                this.getCaptcha()
                this.props.handleSearch()
            }else {
                if (res.code === 'Error') {
                    message.error(res.message)
                    this.getCaptcha()
                }
            }
        }).catch(err => {
            message.error(err.message)
        })
    }

    render () {
        const { getFieldDecorator } = this.props.form
        const { idTypeSelectList } = this.state
        return (
            <Form onSubmit={this.handleSubmit} style={{textAlign:'center'}}>
                <Form.Item>
                    {getFieldDecorator('customerType', {
                        rules: [],
                        initialValue: '1'
                    })(
                        <Select style={{width: 320, height: 40}} onChange={value => this.handleIdType(value)}>
                            <Option value="1">个人</Option>
                            <Option value="0">机构</Option>
                        </Select>
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('identityType', {
                        rules: [],
                        initialValue: '0'
                    })(
                        <Select style={{width: '320px', height: '40px'}}>
                            {
                                idTypeSelectList.map(({title, value}) => {
                                    return (
                                        <Option key={value} value={`${value}`}>{title}</Option>
                                    )
                                })
                            }    
                        </Select>
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('identityNo', {
                        rules: [{ required: true, message: '证件号码不能为空' }],
                    })(
                        <Input
                        style={{width: 320, height:40}}
                        prefix={<span>证件号码</span>}
                        />,
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('password', {
                        rules: [{ required: true, message: '密码不能为空' }],
                    })(
                        <Input
                        type="password"
                        autoComplete="off"
                        style={{width: 320, height:40}}
                        prefix={<span>密码</span>}
                        />,
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('captcha', {
                        rules: [{ required: true, message: '验证码不能为空' }],
                    })(
                        <Input
                        style={{width: 230, height:40}}
                        prefix={<span>验证码：</span>}
                        placeholder="请输入验证码"
                        />,
                    )}
                    <span style={{width:87, height:40, display:'inline-block', position: 'relative', verticalAlign:'top', marginLeft:3, textAlign:'right'}}>
                        <img src={this.state.captchaSrc} alt="validSrc" style={{width:87, height:40}}/>
                        <Button type="link" style={{position:'absolute', right:0, bottom: -30,fontSize:'10px'}} onClick={this.getCaptcha}>看不清，换一张</Button>
                    </span>
                    </Form.Item>
                <Form.Item>
                    <Button htmlType="submit" style={{width:320, height:36, color:'#fff', backgroundColor:'#435EEB'}}>查询</Button>
                </Form.Item>
            </Form>
        )
    }
}
 
export default Form.create()(AchieveAboardForm)